import React from "react";

function H1(props) {
  return <h1 className="p-15 md:p-0 md:pb-20 w-full text-30 leading-30 md:text-40 md:leading-40 font-mont-700 font-w-700 text-center md:text-left">{props.children}</h1>;
}

export default H1;
